import {Component, OnDestroy, OnInit} from '@angular/core';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {RateTypes, SROMaster} from '../hhg-carrier-rate-filing/hhgrates';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {CarrierService} from '../../services/carrier/carrier.service';
import {ISubscription} from 'rxjs-compat/Subscription';
import {UserService} from '../../services/user/user.service';
import {Carrier} from '../../services/carrier/carrier';
import {RateTypesSroService} from '../../services/rate-types-sro/rate-types-sro.service';
import {mergeMap} from 'rxjs-compat/operator/mergeMap';
import {Observable, forkJoin, BehaviorSubject, timer} from 'rxjs';
import {takeWhile, map} from 'rxjs';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';


@Component({
    selector: 'app-rate-carryover',
    templateUrl: './rate-carryover.component.html',
    styleUrls: ['./rate-carryover.component.css'],
    standalone: false
})
export class RateCarryoverComponent implements OnInit, OnDestroy {
  carrier: Carrier;
  rateBidCyclesId: any;
  controlKey: any;
  currentCycleRecords: any;
  rateParam: any;
  rateCarryOver: UntypedFormGroup;
  observer$ = new BehaviorSubject(true);
  showSro: boolean;
  rateTypes: RateTypes[];
  agencies: SROMaster[];
  showForm: Boolean = false;
  bsModalRef: BsModalRef;
  sroCountMap: Map<any, any>;
  ratesCount: any;
  disableAcceptBtn = false;
  closingDate: number = null;
  isValid: boolean;
  isRateFilingClosed$ = new BehaviorSubject(false);


  /**
   * @description injects necessary dependencies
   */
  constructor(private hhgService: HhgCarrierRateFilingService, private fb: UntypedFormBuilder, private router: Router,
              private alertService: AlertService, private tmssloader: LoadingService, private carrierService: CarrierService,
              private userService: UserService, private ratesSroService: RateTypesSroService, private hhgCarrierRateFilingService: HhgCarrierRateFilingService,
              private route: ActivatedRoute, private modalService: BsModalService) {
  }

  /**
   * @description fetches list of rates from the service.
   */
  ngOnInit() {
    this.userService.isRateFilingClosed().subscribe(res => {
      if (res) {
        this.isValid = false;
        this.alertService.warn('Rate Filing Window has been closed!');
      } else {
        this.isValid = true;
      }
    });
    if (this.isValid) {
      this.carrierService.getCarrierObservable()
        .pipe(takeWhile(() => this.observer$.value)).subscribe((carrier: any) => {
        this.carrier = carrier;
      });
      this.route.queryParams.subscribe(params => {
        this.rateParam = params['rateType'];
        if (this.rateParam === 'HHG') {
          this.carrierService.getRateBidCycleId()
            .pipe(takeWhile(() => this.observer$.value)).subscribe((res: any) => {
            this.rateBidCyclesId = res.ratesBidcyclesId;
          });
          this.getRecordsHhg();
        } else if (this.rateParam === 'FRT') {
          this.disableAcceptBtn = true;
          this.carrierService.getRateBidCycleId()
            .pipe(takeWhile(() => this.observer$.value)).subscribe((res: any) => {
            this.rateBidCyclesId = res.ratesBidcyclesId;
          });
          this.showForm = true;
          this.initializeForm();
          this.getRecordsFrt();
          // this.getFrtRateTypes();
          this.getFrtSroTypes();
        }
      });
    }

  }

  /**
   * @description gets the frt rate types
   */
  getFrtSroTypes() {
    this.tmssloader.show();
    this.hhgService.getFrtCarryOverSros(this.rateBidCyclesId, this.carrier.carrierId).pipe(takeWhile(() => this.observer$.value)).subscribe(res1 => {
      // this.tmssloader.hide();
      this.agencies = res1 as SROMaster[];
      let sroListArray = [];
      let sroMasterIdString: any = '';

      this.agencies.forEach(x => {
        sroListArray.push(x.sroMasterId);
      });
      sroMasterIdString = sroListArray.toString();

      this.hhgService.getRateCountForEachSro(this.rateBidCyclesId,
        this.carrier.carrierId,
        sroMasterIdString).subscribe(
        result => {
          this.tmssloader.hide();
          this.sroCountMap = result;
          console.log('sy map test2');
          console.log(this.sroCountMap);
        }
      );
    }, error1 => {
      this.tmssloader.hide();
      this.alertService.error('Error while loading Sro Types. Please contact System Administrator');
    });
  }


  /**
   * @description gets the frt rate types
   */
  getFrtRateTypes() {
    this.hhgService.getFrtCarryForwardRateTypes(this.rateBidCyclesId).pipe(takeWhile(() => this.observer$.value)).subscribe((res1: any) => {
      this.tmssloader.hide();
      this.rateTypes = res1;
    }, error1 => {
      this.tmssloader.hide();
      this.alertService.error('Error while loading Rate Types. Please contact System Administrator');
    });
  }

  /**
   * @description initializes the form
   */
  initializeForm() {
    this.rateCarryOver = this.fb.group({
      'rateTypeId': new UntypedFormControl(null),
      'sroMasterId': new UntypedFormControl('-1')
    });
  }

  /**
   * @description listens to the changes of ratetype list dropdown, gets the records per cycle based on carrierId, controlId, rateTypeId
   * and sroId
   * @param: rate: rate selected by the user
   */
  rateTypeChange() {
    const rateType = this.getFormField('rateTypeId').value;
    this.getFormField('sroMasterId').setValue(null);
    if (rateType !== null && rateType !== '' && rateType !== undefined) {
      if (rateType === -1) {
        this.showSro = false;
        if (this.rateParam === 'FRT') {
          this.hhgService.getFRTRecordsPerCycle([], this.carrier.carrierId, this.rateBidCyclesId, null)
            .pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
            this.currentCycleRecords = res;
          }, error => {
            this.alertService.error('Error occurred while getting no of record per cycle. Please contact system administrator');
          });
        }
      } else {
        this.showSro = true;
        this.getAgenciesByRateType(rateType);
        if (this.rateParam === 'FRT') {
          this.hhgService.getFRTRecordsPerCycle([], this.carrier.carrierId, this.rateBidCyclesId,
            rateType).pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
            this.currentCycleRecords = res;
          }, error => {
            this.alertService.error('Error occurred while getting no of record per cycle. Please contact system administrator');
          });
        }
      }
    }

  }

  /**
   * @description listens to the changes of sro list dropdown gets the records per cycle based on carrierId, controlId, rateTypeId
   * and sroId
   * @param: sro: sro selected by the user
   */
  sroTypeChange(sroMasterIdList: any[]) {
    const sroTypes: any = (JSON.parse(JSON.stringify(this.getFormField('sroMasterId').value)));

    this.disableAcceptBtn = false;
    sroTypes.forEach(x => {
      if ((parseInt(x) == -1) && (parseInt(sroTypes.length) > 1) && (this.disableAcceptBtn == false)) {
        this.disableAcceptBtn = true;
      }
    });
    if (this.disableAcceptBtn) {
      this.alertService.error('When \'All\' is selected, selection of other SRO\'s is not allowed. ');
      return;
    }
    this.ratesCount = 0;
    sroTypes.forEach(x => {
      // console.log(x);
      this.ratesCount += this.sroCountMap[x];
      // console.log(this.sroCountMap[x]);
    });
    console.log('rate type is', this.ratesCount);

    // const sroTypes = this.getFormField('sroMasterId').value;
    /*
     if (sroTypes !== null && sroTypes !== '' && sroTypes !== undefined) {
       if (sroTypes === -1) {
         if (this.rateParam === 'FRT') {
           this.hhgService.getFRTRecordsPerCycle([], this.carrier.carrierId, this.rateBidCyclesId,
             null).pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
             this.currentCycleRecords = res;
           }, error => {
             this.alertService.error('Error occurred while getting no of record per cycle. Please contact system administrator');
           });
         }
       } else {
         if (this.rateParam === 'FRT') {
           this.hhgService.getFRTRecordsPerCycle([sroTypes], this.carrier.carrierId, this.rateBidCyclesId,
             null).pipe(takeWhile(() => this.observer$.value)).subscribe(res => {
             this.currentCycleRecords = res;
           }, error => {
             this.alertService.error('Error occurred while getting no of record per cycle. Please contact system administrator');
           });
         }
       }
     }*/
  }

  /**
   * @description get the no of records per cycle for HHG
   */
  getRecordsHhg() {
    this.tmssloader.show();
    this.hhgService.getHhgRecordsPerCycle([], this.carrier.carrierId, this.rateBidCyclesId, null)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(records => {
      this.ratesCount = records;
      this.currentCycleRecords = records;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('Error occurred while getting no of record per cycle. Please contact system administrator');
    });
  }

  /**
   * @description get the no of records per cycle for FRT
   */
  getRecordsFrt() {
    this.tmssloader.show();
    this.hhgService.getFRTRecordsPerCycle([], this.carrier.carrierId, this.rateBidCyclesId, null)
      .pipe(takeWhile(() => this.observer$.value)).subscribe(records => {
      this.ratesCount = records;
      this.currentCycleRecords = records;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('Error occurred while getting no of record per cycle. Please contact system administrator');
    });
  }

  /*
* @description getFormField for hhgCarrierRates
* */
  getFormField(field: string): any {
    return this.rateCarryOver.get(field);
  }

  /**
   * @description gets the list of agencies/SRO's based on ratetypeId
   */
  getAgenciesByRateType(rateType) {
    this.tmssloader.show();
    this.hhgCarrierRateFilingService.getFrtBidCycleAgencies(this.carrier.carrierId, this.rateBidCyclesId).subscribe(res => {
      this.tmssloader.hide();
      this.agencies = res as SROMaster[];
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('Error while loading SRO values. Please contact system administrator');
    });
  }

  /**
   * @description saves the rates and SRO values and navigates the route to hhgratesdownload/viewFrtRates based on rate type
   */
  acceptCarryOver() {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.question = 'You are about to Accept a carry forward of current rates to the next filing period.  The process of transferring rates from the current period to the next period can ONLY be chosen once, so consider your choice carefully. Please Click "OK" to accept the carry forward of rates, or "Cancel" to go back';
    this.bsModalRef.content.title = 'Accept Carry Forward';
    this.bsModalRef.content.confirmText = 'Ok';
    this.bsModalRef.content.cancelText = 'Cancel';
    // console.log(this.rateCarryOver.get('sroMasterId').value);
    let sroMasterIdsArray = [];
    let sroMasterIdList: any = '';
    if (this.rateParam === 'FRT') {
      const sroTypes: any = (JSON.parse(JSON.stringify(this.getFormField('sroMasterId').value)));
      sroTypes.forEach(e => {
        sroMasterIdsArray.push(e);
      });
      sroMasterIdList = sroMasterIdsArray.toString();
    }

    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        const payLoad = {
          carrierId: this.carrier.carrierId,
          ratesBidcyclesId: this.rateBidCyclesId,
          status: 'Pending'
        };
        if (this.rateParam === 'HHG') {
          this.hhgService.acceptCarryForward(-1, -1, payLoad).subscribe();
          this.alertService.success2('The carry forward processing will take sometime. You will receive an email of the status when the' +
            'process is finished. Please come back later. Thank you');
          setTimeout(() => {
            this.router.navigate(['/', 'landing']);
          }, 5300);
        } else if (this.rateParam === 'FRT') {
          this.hhgService.acceptFrtCarryForward(this.rateCarryOver.get('rateTypeId').value === null ? -1 : this.rateCarryOver.get('rateTypeId').value,
            this.rateCarryOver.get('sroMasterId').value === null ? -1 : sroMasterIdList, payLoad).subscribe();
          this.alertService.success('The carry forward processing will take sometime. You will receive an email of the status when the' +
            'process is finished. Please come back later. Thank you');
          setTimeout(() => {
            this.router.navigate(['/', 'landing']);
          }, 5300);
        } else {
          this.router.navigate(['/', 'error']);
        }
      }
    }, () => {
      this.alertService.warn('Accepting carry forward has been cancelled.');
    });
  }

  /**
   * @description saves the carry forward status as "Rejected" and redirecting to the viewhhgrates/viewFrtRates screen based on rate type.
   */
  rejectCarryOver() {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.question = 'You are about to Reject a carry forward of current rates to the next filing period. The process of transferring rates from the current period to the next period can ONLY be chosen once, so consider your choice carefully.  Please Click "OK" to reject the carry forward of rates, or "Cancel" to go back';
    this.bsModalRef.content.title = 'Reject Carry Forward';
    this.bsModalRef.content.confirmText = 'Ok';
    this.bsModalRef.content.cancelText = 'Cancel';
    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        const payLoad = {
          carrierId: this.carrier.carrierId,
          ratesBidcyclesId: this.rateBidCyclesId,
          status: 'Rejected'
        };
        if (this.rateParam === 'HHG') {
          this.hhgService.saveHhgCarryForward(payLoad).subscribe(res => {
            console.log(res);
          }, error => {
            this.alertService.error('Error occurred while saving the status of HHG carry forward. Please contact system administrator.');
          });
          this.router.navigate(['/', 'viewhhgrates']);
        } else if (this.rateParam === 'FRT') {
          this.hhgService.rejectFrtCarryForward(payLoad).subscribe(res => {
            console.log(res);
          }, error => {
            this.alertService.error('Error occurred while saving the status of FRT carry forward. Please contact system administrator.');
          });
          this.router.navigate(['/', 'viewfrtrates']);
        } else {
          this.router.navigate(['/', 'error']);
        }
      }
    }, () => {
      this.alertService.warn('Rejecting carry forward has been cancelled.');
    });
  }

  /**
   * @description unsubcribes to all the subscriptions if there are any.
   */
  ngOnDestroy(): void {
    this.observer$.next(false);
  }

}
